export function analyticsUrl(value: string | null | undefined, siteUrl: string): string | null {
  if (typeof value !== "string" || !value) return null;
  try {
    const base = new URL(siteUrl);
    const url = new URL(value, base);
    const local = url.hostname === base.hostname ||
      ["miraclassic.com", "www.miraclassic.com"].includes(url.hostname);
    if (local && decodeURIComponent(url.pathname).replace(/\/+$/, "") === "/auth/reset-password") {
      return "/auth/reset-password";
    }
    return value;
  } catch {
    return null;
  }
}
